import React from "react";

//MUI
import SvgIcon from '@mui/material/SvgIcon';

//Types
import { SvgIconProps } from "@mui/material";

interface IGPSOffIcon extends SvgIconProps {
  iconColor?: string;
}

function GPSOffIcon({ iconColor = "#FFFFFF", ...props }: IGPSOffIcon) {
  return <SvgIcon {...props}>
    <svg version="1.1" id="GPSOffIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="24px" height="24px" viewBox="0 0 24 24"
      style={{
        //@ts-ignore
        enableBackground: "new 0 0 24 24"
      }} xmlSpace="preserve">
      <path fill={iconColor} d="M10.995,23v-2.009c-2.093-0.234-3.889-1.101-5.387-2.599c-1.499-1.498-2.365-3.294-2.599-5.387H1v-2.009
	h2.009c0.083-0.703,0.243-1.369,0.477-1.997C3.72,8.371,4.014,7.764,4.365,7.178L1.352,4.164l1.406-1.406l18.484,18.484
	l-1.456,1.406l-2.964-3.014c-0.586,0.352-1.193,0.645-1.821,0.879c-0.628,0.235-1.293,0.394-1.997,0.477V23H10.995z M12,19.032
	c0.602,0,1.189-0.071,1.758-0.213c0.569-0.142,1.105-0.356,1.608-0.64L5.822,8.635c-0.285,0.502-0.498,1.038-0.64,1.607
	C5.039,10.811,4.968,11.397,4.968,12c0,1.943,0.686,3.6,2.059,4.973C8.4,18.346,10.058,19.032,12,19.032z M19.635,16.822
	l-1.456-1.457c0.284-0.502,0.498-1.038,0.64-1.607c0.142-0.569,0.213-1.155,0.213-1.758c0-1.942-0.687-3.599-2.059-4.973
	C15.6,5.655,13.942,4.968,12,4.968c-0.603,0-1.189,0.071-1.758,0.213c-0.569,0.142-1.105,0.356-1.608,0.64L7.178,4.365
	c0.586-0.352,1.193-0.644,1.821-0.879c0.628-0.235,1.293-0.393,1.997-0.477V1h2.009v2.009c2.093,0.235,3.888,1.101,5.387,2.599
	c1.498,1.498,2.365,3.294,2.599,5.387H23v2.009h-2.009c-0.084,0.703-0.243,1.369-0.477,1.997
	C20.279,15.629,19.986,16.236,19.635,16.822z"/>
    </svg>
  </SvgIcon>
}

export default GPSOffIcon;
